/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ROUTES } from '../../assets/constants/strings';
import AccountPagesWrapper from '../../components/Account/PageWrapper';
import Loader from '../../components/Loader';
import Plans from './Plans';
import { usePaddle } from '../../hooks/usePaddle';
import { Button } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';
import {
  CancelUserSubscription,
  GetPaddleUSerSubscription,
  UpdatePaddleSubscription,
} from '../../store/Paddle/paddleActions';
import { UpdateClientSubscription } from '../../store/User/userActions';
import moment from 'moment';

const mapStateToProps = (state) => ({
  loading: state.user.loading,
  user: state.user.user,
  client: state.client,
  isUpdate: state.paddle.isUpdate,
  paymentMethod: state.paddle.paymentMethod,
});

const mapDispatchToProps = {
  UpdatePaddleSubscription,
  UpdateClientSubscription,
  CancelUserSubscription,
};

const PlansPage = ({
  loading,
  user,
  isUpdate,
  UpdatePaddleSubscription,
  paymentMethod,
  UpdateClientSubscription,
  CancelUserSubscription,
}) => {
  const [redirect, setRedirect] = useState(false);
  const [selected, setSelected] = useState({});
  const [isUpdateSubs, setIsUpdateSubs] = useState(false);
  const [redirectHome, setRedirectHome] = useState(false);
  const [redirectUser, setRedirectUser] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [loadingText, setLoadingText] = useState('Loading Plans...');

  const pathname = window.location.pathname;

  const eventCallbackFunction = async (data) => {
    // console.log(data);
    if (data.name === 'checkout.completed') {
      // console.log('data', data);

      setLoadingText('Updating Subscription...');

      const subs = await GetPaddleUSerSubscription(data?.data?.customer?.id);
      // console.log('subs', subs);

      let endDate = '';
      let obj = {};

      if (subs && subs !== undefined) {
        if (
          subs &&
          subs.current_billing_period &&
          subs.current_billing_period.starts_at
        ) {
          const date = moment(subs.current_billing_period.starts_at).add(
            1,
            'month'
          );
          endDate = new Date(date).toISOString();
        } else if (subs.started_at) {
          const date = moment(subs.started_at).add(1, 'month');
          endDate = new Date(date).toISOString();
        }

        obj = {
          clientId: user.userClient.id,
          paddlePlanType: selected.title,
          paddleCustomerId: data?.data?.customer?.id
            ? data?.data?.customer?.id
            : '',
          paddleSubscriptionId: data?.data?.items[0]?.product?.id
            ? data?.data?.items[0]?.product?.id
            : '',
          paddlePriceId: data?.data?.items[0]?.price_id
            ? data?.data?.items[0]?.price_id
            : '',
          planId: selected.id,
          startDate: subs?.current_billing_period?.starts_at
            ? subs?.current_billing_period?.starts_at
            : subs?.started_at
            ? subs?.started_at
            : '',
          endDate: endDate,
          userId: user.userID,
        };
      } else {
        const start = new Date().toISOString();
        const finish = moment(start).add(1, 'month');

        obj = {
          clientId: user.userClient.id,
          paddlePlanType: selected.title,
          paddleCustomerId: data?.data?.customer?.id
            ? data?.data?.customer?.id
            : '',
          paddleSubscriptionId: data?.data?.items[0]?.product?.id
            ? data?.data?.items[0]?.product?.id
            : '',
          paddlePriceId: data?.data?.items[0]?.price_id
            ? data?.data?.items[0]?.price_id
            : '',
          planId: selected.id,
          startDate: new Date().toISOString(),
          endDate: finish.toISOString(),
          userId: user.userID,
        };
      }

      const userRes = await UpdateClientSubscription(obj);
      if (userRes) {
        if (isUpdate) setRedirect(true);
        else setRedirectHome(true);
      }
    }
  };

  const { openCheckout } = usePaddle(
    eventCallbackFunction,
    redirectUser,
    isSignUp
  );

  const [today, setToday] = useState(new Date());

  useEffect(() => {
    if (pathname) setIsUpdateSubs(pathname.includes('update-subscription'));
  }, []);

  const handlePayment = async () => {
    if (isUpdate || isUpdateSubs) {
      setRedirectUser(true);
      if (
        paymentMethod &&
        paymentMethod.type === 'card' &&
        user.userPlan.subscriptionName !== 'Free' &&
        selected.title !== 'Free'
      ) {
        const res = await UpdatePaddleSubscription(
          user.customerPaddleSubsId,
          user.customerPaddleId,
          user.userAddress.id,
          user.userPlan.currency,
          selected.paddlePriceId
        );
        if (res && res.status === 200) {
          const subs = await GetPaddleUSerSubscription(user.customerPaddleId);
          // console.log('subs', subs);

          let endDate = '';
          if (subs && subs.next_billed_at) {
            const date = moment(subs.next_billed_at).add(1, 'month');
            endDate = new Date(date).toISOString();
          } else {
            const date = moment(subs.started_at).add(1, 'month');
            endDate = new Date(date).toISOString();
          }

          const data = {
            clientId: user.userClient.id,
            paddlePlanType: selected.title,
            paddleCustomerId: user.customerPaddleId,
            paddleSubscriptionId: user.customerPaddleId,
            paddlePriceId: selected.paddlePriceId,
            startDate: subs?.started_at ? subs?.started_at : '',
            endDate: endDate,
            planId: selected.id,
            userId: user.userID,
          };
          // console.log('data', data);

          setLoadingText('Updating Subscription...');

          const userRes = await UpdateClientSubscription(data);
          if (userRes && userRes.success) {
            setRedirect(true);
          }
        }
      } else if (selected.title === 'Free') {
        const endDate = moment(today).add(1, 'month');
        const data = {
          clientId: user.userClient.id,
          paddlePlanType: 'FREE',
          paddleCustomerId: '',
          paddleSubscriptionId: '',
          paddlePriceId: '',
          startDate: new Date().toISOString(),
          endDate: new Date(endDate).toISOString(),
          planId: selected.id,
          userId: user.userID,
        };
        // console.log('data', data);

        setLoadingText('Updating Subscription...');

        const userRes = await UpdateClientSubscription(data);
        const res = await CancelUserSubscription(user.customerPaddleSubsId);

        if (userRes && res) {
          setRedirect(true);
        }
      } else getCheckout();
    } else {
      if (selected.title === 'Free') {
        setRedirectUser(true);
        setIsSignUp(true);

        const endDate = moment(today).add(1, 'month');
        const data = {
          clientId: user.userClient.id,
          paddlePlanType: 'FREE',
          paddleCustomerId: '',
          paddleSubscriptionId: '',
          paddlePriceId: '',
          startDate: new Date().toISOString(),
          endDate: new Date(endDate).toISOString(),
          planId: selected.id,
          userId: user.userID,
        };
        // console.log('data', data);

        setLoadingText('Updating Subscription...');

        const userRes = await UpdateClientSubscription(data);
        if (userRes) {
          setRedirectHome(true);
        }
      } else getCheckout();
    }
  };

  const getCheckout = () => {
    const itemsList = [
      {
        priceId: selected.paddlePriceId,
        quantity: 1,
      },
    ];
    openCheckout(itemsList);
  };

  if (redirect) return <Redirect to={ROUTES.MEMBERSHIP_INFO} />;

  if (!user) return <Redirect to={ROUTES.LOGIN} />;

  if (redirectHome) return <Redirect to={ROUTES.HOME} />;

  return (
    <AccountPagesWrapper noContainer hideText className='selectPlans'>
      {loading ? (
        <div className='inner-load'>
          <Loader text={loadingText} />
        </div>
      ) : (
        <>
          <Plans
            selected={selected}
            handleSelected={(plan) => setSelected(plan)}
            isUpdate={isUpdate || isUpdateSubs}
          />
          <Button
            variant='success'
            disabled={!(selected && selected.id && selected.id !== 'custom')}
            onClick={handlePayment}
            className='confirmBtn'
          >
            <span>
              <FaCheck className='mr-2' />
            </span>
            Confirm
          </Button>
        </>
      )}
    </AccountPagesWrapper>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PlansPage);
